// src/axios.js  http://localhost:4000 https://tb-shc2u4o5ja-uc.a.run.app https://tb-441627181374.us-central1.run.app
import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://tb-441627181374.us-central1.run.app'
});

export default instance;
